import { Injectable } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/compat/auth';
// import * as firebase from 'firebase/app'; // Import firebase namespace
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import { Router } from '@angular/router';
import { AngularFirestore, AngularFirestoreDocument } from '@angular/fire/compat/firestore';
import { Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { User } from '../admin/users/users.component';


@Injectable({
    providedIn: 'root'
})
export class AuthService {
    public readonly authState: Observable<firebase.User | null>;

    constructor(
        private afAuth: AngularFireAuth,
        private afs: AngularFirestore,
        private router: Router
    ) {
        this.authState = this.afAuth.authState;
    }

    async signIn(email: string, password: string, rememberMe: boolean): Promise<firebase.auth.UserCredential> {
        const persistence = rememberMe
            ? firebase.auth.Auth.Persistence.LOCAL
            : firebase.auth.Auth.Persistence.SESSION;

        try {
            await this.afAuth.setPersistence(persistence);
            const userCredential = await this.afAuth.signInWithEmailAndPassword(email, password);
            return userCredential;
        } catch (error) {
            console.error("Error during sign in:", error);
            throw error;
        }
    }

    async signUp(email: string, password: string): Promise<firebase.auth.UserCredential> {
        try {
            const userCredential = await this.afAuth.createUserWithEmailAndPassword(email, password);
            const user = userCredential.user;

            if (user) {
                // Create user profile in Firestore using fields from User class
                const userProfile: Partial<User> = {
                    uid: user.uid,
                    email: user.email,
                    registerDate: firebase.firestore.FieldValue.serverTimestamp(), // Use server timestamp
                    lastLogin: firebase.firestore.FieldValue.serverTimestamp(), // Use server timestamp
                    name: user.email, // Default name to email, can be updated later
                    provider: user.providerId || 'password', // Store provider
                    // company: '', // Initialize other fields if needed
                    // street: '',
                    // postcode: '',
                    // city: '',
                    // country: '',
                    // taxid: '',
                    // vms: null
                };
                // Use 'as User' is risky if not all required User fields are present.
                // Using Partial<User> and merge:true is safer.
                await this.afs.doc<User>(`users/${user.uid}`).set(userProfile as User, { merge: true });
            }

            return userCredential;
        } catch (error) {
            console.error("Error during sign up:", error);
            throw error;
        }
    }

    async signOut(): Promise<void> {
        try {
            await this.afAuth.signOut();
        } catch (error) {
            console.error("Error during sign out:", error);
            throw error;
        }
    }

    async sendPasswordResetEmail(email: string): Promise<void> {
        try {
            await this.afAuth.sendPasswordResetEmail(email);
            console.log("Password reset email sent to:", email);
        } catch (error) {
            console.error("Error sending password reset email:", error);
            throw error;
        }
    }
} 